///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, userPreferencesActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getUserPreferences = function* ({ _payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_USER_PREFERENCES()

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(userPreferencesActionCreators.getUserPreferencesSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(userPreferencesActionCreators.getUserPreferencesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const setUserPreference = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const idPreference = payload.idPreference
	const typeURL = payload.typeURL
	const selected = payload.selected

	const apiCall = R.SET_USER_PREFERENCE(idPreference, typeURL, selected)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(userPreferencesActionCreators.setUserPreferenceSuccess(data.data, typeURL))

		yield put(toastSuccessActionCreators.hydrateToast('toast__preference__modified'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(userPreferencesActionCreators.setUserPreferenceFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_USER_PREFERENCES, getUserPreferences)
	yield takeLatest(ActionsTypes.SET_USER_PREFERENCE, setUserPreference)
}

export default sagas
